import { Tooltip } from '@mantine/core';
import classnames from 'classnames';

import styles from './MultiDayEventBanner.module.scss';
import { Props } from './MultiDayEventBanner.types';

const MultiDayEventBanner = ({
  eventId,
  isStart,
  isEnd,
  isFirstDayShown,
  topPx,
  name,
  description,
  onClick,
  color,
  initial,
}: Props) => {
  const label = name + (description ? ` (${description})` : '');
  const showLabel = isStart || isFirstDayShown;

  return (
    <Tooltip
      label={label}
      transitionProps={{ transition: 'fade-up', duration: 300 }}
      openDelay={500}
    >
      <div
        key={eventId}
        className={classnames(styles.event, {
          [styles.isStart]: isStart,
          [styles.isEnd]: isEnd,
        })}
        style={{
          top: `${topPx}px`,
          backgroundColor: color,
        }}
        onClick={e => {
          e.stopPropagation();
          onClick();
        }}
      >
        <div className={styles.eventContent}>
          {showLabel && initial && <span className={styles.initial}>{initial}</span>}
          {showLabel && <span className={styles.eventText}>{label}</span>}
        </div>
      </div>
    </Tooltip>
  );
};

export default MultiDayEventBanner;
